<template>
    <div class="dashboard dashboard-layout">
        <template v-if="!loading">
            <dashboard-header :headerImage="headerImageSettings" @openModal="openModal" @closeModal="closeModal"/>
            <dashboard-filters />
            <main class="dashboard-content">
                <dashboard-new />

                <dashboard-enquiries-list v-if="getSelectedTab === 'requests'" v-model="enquiries" />
                <dashboard-tasks-list v-if="getSelectedTab === 'tasks'" v-model="tasks" />
                <dashboard-requisition-list v-if="getSelectedTab === 'requisitions'" v-model="requisitions" />
                <dashboard-routines-list v-if="getSelectedTab === 'routines'" v-model="routines" />
                <dashboard-templates-list v-if="getSelectedTab === 'templates'" v-model="templates" />
            </main>
        </template>
        <div v-else class="loading-div">
            <h1 class="loading-header">Danner dit overblik...</h1>
        </div>

        <modal v-if="showModal" :type="modalType" :data="modalData" @close="closeModal" />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import header from '../components/pages/dashboard/dashboard-header.vue'
import filters from '../components/pages/dashboard/dashboard-filters.vue'
import newWork from '../components/pages/dashboard/dashboard-new-work.vue'
import enquiries from '../components/shared/list/list-enquiries.vue'
import tasks from '../components/shared/list/list-tasks.vue'
import requisitions from '../components/shared/list/list-requisitions.vue'
import routines from '../components/shared/list/list-routines.vue'
import templates from '../components/shared/list/list-templates.vue'
import modal from '../components/shared/modal/modal.vue'

export default {
    name: 'dashboard',
    components: {
        modal,
        'dashboard-header': header,
        'dashboard-filters': filters,
        'dashboard-new': newWork,
        'dashboard-enquiries-list': enquiries,
        'dashboard-tasks-list': tasks,
        'dashboard-requisition-list': requisitions,
        'dashboard-routines-list': routines,
        'dashboard-templates-list': templates
    },
    data () {
        return {
            loading: false,
            showModal: false,
            modalType: '',
            modalData: '',
            // filtering
            headerImageSettings: {
                show: true
            }
        }
    },
    computed: {
        ...mapGetters({
            firstTimeLogIn: 'firstTimeLogIn',
            getTabs: 'getTabs',
            getSelectedTab: 'getSelectedTab',
            permissions: 'permissions',
            userId: 'getUserId',
            enquiries: 'getRequestList',
            tasks: 'getTaskList',
            requisitions: 'getRequisitionList',
            routines: 'getRoutineList',
            templates: 'getTemplateList',
            users: 'getAllUsersInFirmForActivity',
            // filtering
            userInfo: 'userInfo',
            supplyTypes: 'getBusinessAreaTypes'
        })
    },
    methods: {
        ...mapActions({
            setEnquiryAddressToTask: 'setEnquiryAddressToTask',
            setRequestOnTaskListFromEnquiry: 'setRequestOnTaskListFromEnquiry',
            setReportClear: 'setReportClear',
            startCircleAnimation: 'startCircleAnimation',
            setFirstTimeLogIn: 'setFirstTimeLogIn',
            getUserList: 'getAssociatedOrganizationUserList',
            // filtering
            setSelectedTab: 'setSelectedTab',
            setFilters: 'setFilters',
            resetFilters: 'resetFilters'
        }),
        openModal (type, data) {
            this.modalType = type
            this.modalData = data
            this.showModal = true
            console.log(type, data)
        },
        closeModal () {
            this.showModal = false
        },
        wait (ms) {
            return (x) => {
                return new Promise(resolve => setTimeout(() => resolve(x), ms))
            }
        },
        getCookie (cname) {
            var name = cname + '='
            var decodedCookie = decodeURIComponent(document.cookie)
            var ca = decodedCookie.split(';')
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i]

                while (c.charAt(0) === ' ') {
                    c = c.substring(1)
                }

                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length)
                }
            }
            return ''
        },
        setCookie (cname, cvalue, exdays) {
            var d = new Date()
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
            var expires = 'expires=' + d.toUTCString()
            document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
        }
    },
    async created () {
        if (this.$route.hash && this.getTabs.some(t => t.name === this.$route.hash.replace('#', ''))) {
            this.setSelectedTab(this.$route.hash.replace('#', ''))
        }

        this.loading = true
        this.setEnquiryAddressToTask({})
        this.setRequestOnTaskListFromEnquiry([])
        this.setReportClear()

        if (this.firstTimeLogIn) {
            await this.resetFilters('user')
            await this.getUserList({firmaId: this.userInfo.organizationId, initialOrganization: true})
        }

        this.loading = false
        await this.wait(300)
        if (this.firstTimeLogIn) {
            this.startCircleAnimation(true)
            this.setFirstTimeLogIn(false)
        }
    },
    mounted () {
        if (!this.permissions.requests.enabled && !this.permissions.tasks.enabled && this.permissions.requisitions.enabled) {
            this.setFilters({
                page: 'requisitions',
                filter: 'company',
                value: this.userInfo.organizationId
            })
            this.setFilters({
                page: 'requisitions',
                filter: 'contact',
                value: this.userInfo.userId
            })
        }
        if (this.$root.$children[0].$refs.baseMap) {
            this.$root.$children[0].$refs.baseMap.hideMap()
        }
    }
}
</script>

<style lang="scss">
@import '../scss/components/loader';
@import '../scss/pages/dashboard';

.loading-div {
    height: calc(100vh - 60px);
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard.vue